'use strict';
import { BaseService } from '@narrate/base-sdk';

const OPTIONS = {
  gender: ['male', 'female', 'other'],
};

const VALIDATIONS = {
  birthdate: { date: true },
  gender: { inclusion: { within: OPTIONS.gender } },
};

/**
 * uses attributes api to store and retrieve the user profile
 *
 * future work:
 *  may handle conflict resolution
 *
 * @example
 *    // using CoreService (recommended)
 *    import Core from '@narrate/core-sdk';
 *
 *    const { value: profile } = await Core.api.profile.get();
 *    console.log(profile); // should be something like { birthdate: }
 *
 *    await Core.api.profile.save({ videos: [] });
 */
class ProfileService extends BaseService {

  constructor() {
    super({ configPath: 'services.profile' });
  }

  find = async userId => {
    if (userId) {
      return await this.requestResource('get', {
        params: { userId },
        tokenType: 'none',
      });
    } else {
      return await this.requestRootResource();
    }
  }

  findByUsername = async username => {
    console.log('profile service username = ', username);
    if (username) {
      return await this.requestResource('getByUsername', {
        params: { username },
        tokenType: 'none',
      });
    } else {
      return await this.requestResource();
    }
  }

  /**
   * Gets the user's public profile view which is a projection of the profile and some of the user's access blocks.
   * This was originally used in the stateless weborder process, now ported into the main SDK as a convenience.
   * 
   * USAGE NOTE: find and findByUsername should still be used to fetch the user's profile if it is known you do not need a heavy view projection
   * 
   * @param {string} username 
   * @param {number} fetchSize 
   */
  profileView = async (username, fetchSize = 20) => {
    console.log("profile service username = ", username, fetchSize);
    if(username) {
      return await this.requestResource('profileView', {
        params: { username, fetchSize },
        tokenType: 'none'
      });
    } else {
      return await this.requestResource(); //[HQT] - i honestly dont know what this does -- returning to it
    }
  }

  getLink = async username => {
    console.log('profile service username = ', username);
    if (username) {
      console.log('DEBUG::getLink for user:', username);
      return await this.requestResource('getLink', {
        params: { username },
        tokenType: 'none',
      });
    } else {
      return await this.requestResource();
    }
  }

  save = async profile => {
    return await this.requestRootResource({
      method: 'post',
      data: profile,
    });
  }

  blockUser = async userId => {
    return await this.requestResource('blockUser', {
      method: 'post',
      data: { userId, blocked: true },
    });
  }

  unblockUser = async userId => {
    return await this.requestResource('blockUser', {
      method: 'post',
      data: { userId, blocked: false },
    });
  }
}

ProfileService.OPTIONS = OPTIONS;

export default ProfileService;
